import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import {
  RoomBrandCreateVO,
  RoomBrandDeleteVO,
  RoomBrandUpdateVO,
  RoomBrandUseVO
} from "@youm-front/room/domain";
import { RoomBrandActions } from "../actions";
import { RoomBrandSelectors } from "../selectors";

@Injectable()
export class RoomBrandFacade {
  isLoading$ = this.store.pipe(select(RoomBrandSelectors.isLoading));

  constructor(private readonly store: Store) {}

  roomBrandCreate(roomBrandCreateVO: RoomBrandCreateVO) {
    this.store.dispatch(
      RoomBrandActions.roomBrandCreate({
        roomBrandCreateVO
      })
    );
  }

  roomBrandDelete(roomBrandDeleteVO: RoomBrandDeleteVO) {
    this.store.dispatch(
      RoomBrandActions.roomBrandDelete({
        roomBrandDeleteVO
      })
    );
  }

  roomBrandUpdate(roomBrandUpdateVO: RoomBrandUpdateVO) {
    this.store.dispatch(
      RoomBrandActions.roomBrandUpdate({ roomBrandUpdateVO })
    );
  }

  roomBrandUse(roomBrandUseVO: RoomBrandUseVO) {
    this.store.dispatch(
      RoomBrandActions.roomBrandUse({
        roomBrandUseVO
      })
    );
  }
}
